import { useEffect } from "react";
import PropTypes from "prop-types";
import AOS from "aos";
import "aos/dist/aos.css";

const SectionHeader = ({ title, caption, left }) => {
  useEffect(() => {
    AOS.init({ duration: 500 });
  }, []);
  return (
    <div
      data-aos="zoom-in"
      className={`${
        left
          ? "text-center lg:text-left items-center lg:items-start"
          : "text-center items-center"
      } sys_black flex flex-col mb-8`}
    >
      <h1 className="font-black text-3xl">{title}</h1>
      {caption && <p className="mt-4 lg:text-xl max-w-xl">{caption}</p>}
    </div>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string,
  caption: PropTypes.string,
  left: PropTypes.bool,
};

export default SectionHeader;
